import { createLocalResource } from 'app/libs/createLocalResource'

export const localResource = createLocalResource(() => 'global_message')
